import { ghostButton } from './RegistrationLandingPage.css';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import React from 'react';

class GhostButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onMouseEnter() {
    this.setState({ hover: true });
  }
  onMouseLeave() {
    this.setState({ hover: false });
  }
  render() {
    return (
      <Link
        to={this.props.path}
        onMouseEnter={() => this.onMouseEnter()}
        onMouseLeave={() => this.onMouseLeave()}
        style={ghostButton(this.state.hover)}
      >
        {this.props.text}
      </Link>
    );
  }
}

export default GhostButton;
